import { render, staticRenderFns } from "./expressDialog.vue?vue&type=template&id=10fc2c98&scoped=true"
import script from "./expressDialog.vue?vue&type=script&lang=js"
export * from "./expressDialog.vue?vue&type=script&lang=js"
import style0 from "./expressDialog.vue?vue&type=style&index=0&id=10fc2c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fc2c98",
  null
  
)

export default component.exports